import {ReducerStatuses} from "services/utils/utils";
import {createSlice} from "@reduxjs/toolkit";
import {keyBy} from "lodash";
import {CompanyUpsertFormBaseState} from "features/forms/company-upsert";
import {resetAuth} from "store/reducer/auth/reducer";

export const initialState = {
    data: {},
    selected: null,
    get: {
        status: ReducerStatuses.IDLE,
        error: ""
    },
    upsert: {
        status: ReducerStatuses.IDLE,
        error: ""
    },
    code: {
        status: ReducerStatuses.IDLE,
        error: ""
    },
    delete: {
        status: ReducerStatuses.IDLE,
        error: ""
    }
};

const slice = createSlice({
    name: "company",
    initialState,
    reducers: {
        getCompaniesStart: (state) => {
            state.get.status = ReducerStatuses.LOADING;
        },
        getCompaniesError: (state, {payload}) => {
            state.get.status = ReducerStatuses.ERROR;
            state.get.error = payload;
        },
        getCompaniesSuccess: (state, {payload}) => {
            state.get.status = ReducerStatuses.SUCCESS;
            state.data = keyBy(payload, "id");
        },
        newCompany: (state) => {
            state.selected = {...CompanyUpsertFormBaseState}
        },
        editCompany: (state, {payload}) => {
            state.selected = {
                ...CompanyUpsertFormBaseState,
                ...payload
            }
        },
        resetUpsertCompany: (state) => {
            state.selected = null;
            state.upsert.status = ReducerStatuses.IDLE;
        },
        upsertCompanyStart: (state, {payload}) => {
            state.upsert.status = ReducerStatuses.LOADING;
            state.selected = payload;
        },
        upsertCompanyError: (state, {payload}) => {
            state.upsert.status = ReducerStatuses.ERROR;
            state.upsert.error = payload;
        },
        upsertCompanySuccess: (state) => {
            state.upsert.status = ReducerStatuses.SUCCESS;
            state.selected = null;
        },
        startResetCompanyCode: (state) => {
            state.code.status = ReducerStatuses.LOADING;
        },
        errorResetCompanyCode: (state, {payload}) => {
            state.code.status = ReducerStatuses.ERROR;
            state.code.error = payload;
        },
        successResetCompanyCode: (state) => {
            state.code.status = ReducerStatuses.SUCCESS;
        },
        startDeleteCompany: (state) => {
            state.delete.status = ReducerStatuses.LOADING;
        },
        errorDeleteCompany: (state, {payload}) => {
            state.delete.status = ReducerStatuses.ERROR;
            state.delete.error = payload;
        },
        successDeleteCompany: (state) => {
            state.delete.status = ReducerStatuses.SUCCESS;
        }
    },
    extraReducers: {
        [resetAuth]: (state) => {
            state.data = {}
            state.selected = null;
        }
    }
});

const {reducer, actions} = slice;
export const {
    getCompaniesStart, getCompaniesError, getCompaniesSuccess, newCompany, editCompany, resetUpsertCompany,
    upsertCompanyStart, upsertCompanyError, upsertCompanySuccess, startResetCompanyCode, errorResetCompanyCode, successResetCompanyCode,
    errorDeleteCompany, startDeleteCompany, successDeleteCompany
} = actions;
export default reducer;